<template><section><template>
<h3>Modal</h3>
<div class="bs-docs-section">
<div class="bs-example">
<blockquote>
<p>component</p>
</blockquote>
<p><n3-button @click.native="showModal">Show modal</n3-button>
<n3-modal title="Modal title" effect="fade" width="400px" ref="modal"></n3-modal></p>
  <div slot="body">
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  </div>

<n3-button class="btn btn-success" @click.native="showBigModal">Big modal</n3-button>
<n3-modal title="Big Modal" effect="fade" width="800px" ref="bigModal">
  <div slot="body">
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  </div>
</n3-modal>
<n3-button class="btn btn-primary" @click.native="showZoomModal">Zoom modal</n3-button>
<n3-modal title="Zoom Modal" effect="zoom" width="400px" ref="zoomModal">
  <div slot="body">
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  </div>
</n3-modal>
<n3-button @click.native="showCustomModal">Show custom modal</n3-button>
<n3-modal effect="fade" width="400px" ref="customModal">
  <div slot="header">
  </div>
  <div slot="body">
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  </div>
  <div slot="footer">
  </div>
</n3-modal>
<n3-button @click.native="showConfirm">Show confirm</n3-button>
<n3-button @click.native="showAlert">Show alert</n3-button>
</div>
<hr>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showModal"</span>&gt;</span>Show modal<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-modal</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Modal title"</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"400px"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"modal"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"body"</span>&gt;</span>
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-modal</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"btn btn-success"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showBigModal"</span>&gt;</span>Big modal<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-modal</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Big Modal"</span>  <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"800px"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"bigModal"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"body"</span>&gt;</span>
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-modal</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"btn btn-primary"</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showZoomModal"</span>&gt;</span>Zoom modal<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-modal</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"Zoom Modal"</span> <span class="hljs-attr">effect</span>=<span class="hljs-string">"zoom"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"400px"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"zoomModal"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"body"</span>&gt;</span>
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-modal</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-button</span> <span class="hljs-attr">@click.native</span>=<span class="hljs-string">"showCustomModal"</span>&gt;</span>Show custom modal<span class="hljs-tag">&lt;/<span class="hljs-name">n3-button</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-modal</span>  <span class="hljs-attr">effect</span>=<span class="hljs-string">"fade"</span> <span class="hljs-attr">width</span>=<span class="hljs-string">"400px"</span> <span class="hljs-attr">ref</span>=<span class="hljs-string">"customModal"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"header"</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"body"</span>&gt;</span>
    What's in a name? That which we call a rose
    By any other name would smell as sweet.
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"footer"</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-modal</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
    }
  },
  <span class="hljs-attr">methods</span>: {
    showModal () {
      <span class="hljs-keyword">this</span>.$refs.modal.open()
    },
    showBigModal () {
      <span class="hljs-keyword">this</span>.$refs.bigModal.open()
    },
    showZoomModal () {
      <span class="hljs-keyword">this</span>.$refs.zoomModal.open()
    },
    showCustomModal () {
      <span class="hljs-keyword">this</span>.$refs.customModal.open()
    }
  }
}
</code></pre>
<hr>
<blockquote>
<p>methods</p>
</blockquote>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    showAlert () {
      <span class="hljs-keyword">this</span>.n3Modal.alert({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'Title'</span>
        message: <span class="hljs-string">'This is a  Modal。'</span>,
        <span class="hljs-attr">effect</span>: <span class="hljs-string">'fade'</span>,
        <span class="hljs-attr">type</span>: <span class="hljs-string">'info'</span>,
        onShow () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'open'</span>)
        },
        onHide () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'close'</span>)
        }
      })
    },
    showConfirm () {
      <span class="hljs-keyword">this</span>.n3Modal.confirm({
        <span class="hljs-attr">title</span>: <span class="hljs-string">'Title'</span>,
        <span class="hljs-attr">message</span>: <span class="hljs-string">'This is a Modal。'</span>,
        <span class="hljs-attr">effect</span>: <span class="hljs-string">'zoom'</span>,
        <span class="hljs-attr">type</span>: <span class="hljs-string">'success'</span>,
        onShow () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'open'</span>)
        },
        onConfirm () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'confirm'</span>)
        },
        onHide () {
          <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'hide'</span>)
        }
      })
    }
  }
}
</code></pre>
<hr>
<h3>components</h3>
<h4>Params</h4>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>title</td>
</tr>
<tr>
<td>effect</td>
<td><code v-pre="">String</code></td>
<td>'fade'</td>
<td><code v-pre="">fade``zoom</code></td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">600px</code></td>
<td></td>
</tr>
<tr>
<td>backdrop</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>Click whether the mask layer closes the pop-up box</td>
</tr>
</tbody>
</table>
<h4>Events</h4>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>show</td>
<td>show</td>
</tr>
<tr>
<td>hide</td>
<td>hide</td>
</tr>
<tr>
<td>confirm</td>
<td>confirm</td>
</tr>
</tbody>
</table>
<h4>Methods</h4>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>open</td>
<td>open  Modal</td>
</tr>
<tr>
<td>close</td>
<td>close  Modal</td>
</tr>
<tr>
<td>confirm</td>
<td>emit confirm event</td>
</tr>
</tbody>
</table>
<hr>
<h3>Methods</h3>
<blockquote>
<p>Directly in the instance call <code v-pre="">this.n3Model</code> modal creation and operation</p>
</blockquote>
<h4>Params</h4>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>title</td>
</tr>
<tr>
<td>message</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>message</td>
</tr>
<tr>
<td>effect</td>
<td><code v-pre="">String</code></td>
<td>'fade'</td>
<td><code v-pre="">fade``zoom</code></td>
</tr>
<tr>
<td>type</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">600px</code></td>
<td>Modal type, used to determine Modal prompt icon.</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">600px</code></td>
<td>width</td>
</tr>
<tr>
<td>onShow</td>
<td><code v-pre="">Function</code></td>
<td></td>
<td>The callback function when the Modal is opened</td>
</tr>
<tr>
<td>onHide</td>
<td><code v-pre="">Function</code></td>
<td></td>
<td>The callback function when the Modal is opened</td>
</tr>
<tr>
<td>onConfirm</td>
<td><code v-pre="">Function</code></td>
<td></td>
<td>Click the callback function when the Modal determines the button</td>
</tr>
</tbody>
</table>
<h3>Usage</h3>
<h4>component</h4>
<p>If you need to customize the contents of the Modal, you can achieve it</p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"header"</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"body"</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"footer"</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
</code></pre>
<h4>Methods</h4>
<p>N3 provides a function-driven one-time modal, invoked by the instance attributes n3Modal.alert and n3Modal.confirm, which are dynamically bound to the DOM tree when used and automatically destroyed after shutdown.</p>
<p>In order to restore the native dialog operation experience, the function-driven Modal will not be closed by clicking on the background.</p>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">const</span> options = {...}

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    showAlert () {
      <span class="hljs-keyword">this</span>.n3Modal.alert(options)
    },
    showConfirm () {
      <span class="hljs-keyword">this</span>.n3Modal.confirm(options)
    }
  }
}

</code></pre>
</div>
</template>
</section></template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    showModal () {
      this.$refs.modal.open()
    },
    showBigModal () {
      this.$refs.bigModal.open()
    },
    showZoomModal () {
      this.$refs.zoomModal.open()
    },
    showCustomModal () {
      this.$refs.customModal.open()
    },
    show () {
      console.log('show')
    },
    showConfirm () {
      this.n3Modal.confirm({
        title: 'Title',
        message: 'This is a Modal',
        effect: 'zoom',
        type: 'info',
        onShow () {
          console.log('open')
        },
        onConfirm () {
          console.log('confirm')
        },
        onHide () {
          console.log('hide')
        }
      })
    },
    showAlert () {
      this.n3Modal.alert({
        title: 'title',
        message: 'This is a Modal',
        effect: 'fade',
        type: 'success',
        onShow () {
          console.log('open')
        },
        onHide () {
          console.log('hide')
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3ModalDocs.md?7e544c24